module.exports = __webpack_public_path__ + "img/img_carousel.ba91da4b.webp";